module.exports = __webpack_public_path__ + "static/media/RedKnot_Verified.44e2f4a2.svg";